import { useNavButtons } from '../../common/NavButtonsProvider';
import { useParams } from '../../router/Router';

export default function TournamentsByDateData(props) {
    const navButtons = useNavButtons();
    const p = useParams();

    const btn = p.hour ? navButtons[0] : navButtons[p.day - 1];

    if (btn == null) {
        return null;
    }

    const day = btn;
    const data = {date: day.date, sportId: day.sport.id, aggId: day.sport.aggregata};

    return props.renderItem(data);
}
